import { ApprovedContributor } from '@models';

export interface ApprovedContributorsResult {
  approvedContributorsList: ApprovedContributor[];
}
